import { camelToWords } from '@/utils/stringHelper'
import React from 'react'
import SystemVariableListPage from './SystemVariableListPage'

const SystemVariableBreadcrumb = ({ match }) => <>{`${camelToWords(match.params.type)}`}</>
const systemVariableRoutes = [
  {
    breadcrumb: SystemVariableBreadcrumb,
    path: ':type',
    element: <SystemVariableListPage />,
    children: [],
  },
]

export const hsCodeRoutes = [
  {
    breadcrumb: SystemVariableBreadcrumb,
    path: ':type',
    element: <SystemVariableListPage />,
    children: [],
  },
]
export default systemVariableRoutes
